var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-settings"},[_c('b-card',[(!_vm.siteSettings || _vm.loading)?_c('spinner'):[_c('form-generator',{attrs:{"elements":_vm.elements,"data":_vm.siteSettings,"handleUpdate":_vm.handleUpdate}})]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }